// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1t0om","log":"ModalInventoryLogs_log__3FpfE","date":"ModalInventoryLogs_date__37HkS","userName":"ModalInventoryLogs_userName__1wg0A"};